export class BuildDetails {
    buildNumber: string;
    disableDragDropRoutes?: string[];
}